/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Box_Score_HintInputs */

const th_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เว้นว่างหากไม่ได้บันทึกสถิติ ศูนย์หมายถึงบันทึกค่าเป็นศูนย์`)
};

const en_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave a count blank if it was not recorded. Zero means a recorded zero.`)
};

const ja_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記録していない項目は空欄にしてください。0は記録されたゼロを意味します。`)
};

const zh_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`若未做记录，可将该栏留空。零表示记录到的零。`)
};

const es_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja un valor en blanco si no se registró. Cero significa un cero registrado.`)
};

const pt_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe em branco se não foi registrado. Zero significa um zero registrado.`)
};

const id_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosongkan kolom jika tidak ada yang dicatat. Nol berarti nol yang dicatat.`)
};

const fr_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laissez vide si ce n’était pas relevé. Zéro signifie un zéro relevé.`)
};

const tl_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iwanang blangko ang kahon kung walang naitala. Ang zero ay isang naitalang zero.`)
};

const vi_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để trống ô nếu không ghi nhận gì. Số không nghĩa là một số không đã ghi nhận.`)
};

const ko_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기록된 것이 없으면 칸을 비워 두세요. 0은 기록된 0을 뜻합니다.`)
};

const de_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lass ein Feld leer, wenn nichts erfasst wurde. Null bedeutet eine erfasste Null.`)
};

const ru_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставьте поле пустым, если ничего не фиксировали. Ноль означает записанный ноль.`)
};

const tr_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıt yoksa alanı boş bırakın. Sıfır, kaydedilmiş bir sıfır demektir.`)
};

const it_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia vuota la casella se non è stato registrato nulla. Zero significa uno zero registrato.`)
};

const pl_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zostaw pole puste, jeśli nic nie zapisano. Zero oznacza zapisane zero.`)
};

const uk_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Залиште поле порожнім, якщо нічого не фіксували. Нуль означає записаний нуль.`)
};

const hi_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगर कुछ दर्ज नहीं हुआ तो खाना खाली छोड़ें। शून्य का अर्थ है दर्ज किया गया शून्य।`)
};

const ar_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اترك الخانة فارغة إن لم يُسجَّل شيء. الصفر يعني صفرًا مسجَّلًا.`)
};

const ms_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biarkan kotak kosong jika tiada apa direkodkan. Sifar bermakna sifar yang direkodkan.`)
};

const bn_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কিছু নথিভুক্ত না হলে ঘর ফাঁকা রাখুন। শূন্য মানে নথিভুক্ত শূন্য।`)
};

const zh_tw2_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`若未記錄任何內容，請留空。零代表記錄到的零。`)
};

const zh_hk2_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`若未記錄任何內容，請留空。零代表記錄到的零。`)
};

const ur_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اگر کچھ درج نہیں ہوا تو خانہ خالی چھوڑ دیں۔ صفر کا مطلب درج شدہ صفر ہے۔`)
};

const fa_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اگر چیزی ثبت نشده خانه را خالی بگذارید. صفر یعنی صفرِ ثبت‌شده.`)
};

const sw_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acha kisanduku wazi kama hakuna kilichorekodiwa. Sifuri ina maana ya sifuri iliyorekodiwa.`)
};

const nl_game_box_score_hint = /** @type {(inputs: Game_Box_Score_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laat een vak leeg als er niets is bijgehouden. Nul betekent een genoteerde nul.`)
};

/**
* | output |
* | --- |
* | "Leave a count blank if it was not recorded. Zero means a recorded zero." |
*
* @param {Game_Box_Score_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const game_box_score_hint = /** @type {((inputs?: Game_Box_Score_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Box_Score_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_game_box_score_hint(inputs)
	if (locale === "ja") return ja_game_box_score_hint(inputs)
	if (locale === "zh") return zh_game_box_score_hint(inputs)
	if (locale === "es") return es_game_box_score_hint(inputs)
	if (locale === "pt") return pt_game_box_score_hint(inputs)
	if (locale === "id") return id_game_box_score_hint(inputs)
	if (locale === "fr") return fr_game_box_score_hint(inputs)
	if (locale === "tl") return tl_game_box_score_hint(inputs)
	if (locale === "vi") return vi_game_box_score_hint(inputs)
	if (locale === "ko") return ko_game_box_score_hint(inputs)
	if (locale === "de") return de_game_box_score_hint(inputs)
	if (locale === "ru") return ru_game_box_score_hint(inputs)
	if (locale === "tr") return tr_game_box_score_hint(inputs)
	if (locale === "it") return it_game_box_score_hint(inputs)
	if (locale === "pl") return pl_game_box_score_hint(inputs)
	if (locale === "uk") return uk_game_box_score_hint(inputs)
	if (locale === "hi") return hi_game_box_score_hint(inputs)
	if (locale === "ar") return ar_game_box_score_hint(inputs)
	if (locale === "ms") return ms_game_box_score_hint(inputs)
	if (locale === "bn") return bn_game_box_score_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_game_box_score_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_game_box_score_hint(inputs)
	if (locale === "ur") return ur_game_box_score_hint(inputs)
	if (locale === "fa") return fa_game_box_score_hint(inputs)
	if (locale === "sw") return sw_game_box_score_hint(inputs)
	if (locale === "nl") return nl_game_box_score_hint(inputs)
	return en_game_box_score_hint(inputs)
});